import { useMutation } from "@tanstack/react-query";
import { resend } from "../../API/functions";
import { toast } from "react-toastify";

export const useResendOTP = () => {
  const { mutate ,isPending } = useMutation({
    mutationFn: (vars) => resend(vars),
    onSuccess: (data) => {
      toast.success(data.message);
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.message || "Something went wrong!";
      toast.error(errorMessage);
    },
  });

  return { mutate,isPending };
};
